














import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import InvestigationModel from '@/models/investigation/investigationModel'
import ListSectionModel from '@/models/navigation/listSectionModel'
import NavigationModel from '@/models/navigation/navigationModel'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'
import ExtensionModel from '../models/extension/extensionModel'
import SectionedList from '@/components/lists/SectionedList.vue'
import ExtensionModule from '../store/extensionModule'

const titleModule = getModule(TitleModule)
const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    SectionedList
  }
})
export default class ExtensionAdmin extends Vue {
  // Extension Id
  @Prop(String) readonly id!: string

  private extension: ExtensionModel = new ExtensionModel()

  private categories: Array<ListSectionModel<NavigationModel>> = [
    new ListSectionModel<NavigationModel>('Extension Information', [
      new NavigationModel('Scene Management', 'stage-admin', {
        stage: 'scene-management'
      }),
      new NavigationModel('Equipment', 'stage-admin', {
        stage: 'equipment'
      }),
      new NavigationModel('Personnel', 'stage-admin', {
        stage: 'personnel-profiles'
      }),
      new NavigationModel('Documents', 'stage-admin', {
        stage: 'documents'
      }),
      new NavigationModel('Witness Interviews', 'stage-info-admin', {
        stage: 'witness-interviews'
      })
    ]),
    new ListSectionModel<NavigationModel>('Extension Outcomes', [
      new NavigationModel('Suggested Actions', 'prompts-admin', {
        id: this.id
      }),
      new NavigationModel('Best Practice', 'stage-info-admin', {
        stage: 'best-practice'
      })
    ])
  ]

  private async created() {
    await this.getExtension()
  }

  private navigate(item: NavigationModel): void {
    this.$router.push({
      name: item.route,
      params: item.params
    })
  }

  private async getExtension(): Promise<void> {
    this.extension = await ApiService.get<ExtensionModel>(
      UrlType.Extension,
      this.id
    )
    extensionModule.setExtension(this.extension)
    titleModule.setPageTitle(this.extension.name)
  }
}
